import {
  QUERY_PARAM_SLIDES,
  QUERY_PARAM_PARENT_PRODUCT,
  QUERY_PARAM_EMBED,
  QUERY_PARAM_HIDE_BORDER,
  QUERY_PARAM_NATIVE_EMBED_VIEW,
} from '@canvas/constants/query-params';

/**
 * Gets search params that are used for embedded mode (EAP)
 * @returns containerAri search params
 */
export const getEmbedSearchParams = () => {
  // Adding a fallback here to satisfy unit tests where jsdom hasn't been set up yet
  const href = globalThis.location?.href ?? 'ws://.';
  const url = new URL(href);

  const containerAri = url.searchParams.get('containerAri');
  const parentProduct = url.searchParams.get(QUERY_PARAM_PARENT_PRODUCT);
  const embed = url.searchParams.get(QUERY_PARAM_EMBED) === 'true';
  const hideBorder = url.searchParams.get(QUERY_PARAM_HIDE_BORDER) === 'true';
  const nativeEmbedView = url.searchParams.get(QUERY_PARAM_NATIVE_EMBED_VIEW) === 'true';
  const slides = url.searchParams.get(QUERY_PARAM_SLIDES);

  return {
    containerAri,
    parentProduct,
    embed,
    hideBorder,
    nativeEmbedView,
    slides,
  };
};
